<template>
  <div class="background">
    <div class="background__inner">
      <div class="an-adn" id="adn_01"></div>
      <div class="an-adn" id="adn_02"></div>
      <div class="an-adn" id="adn_03"></div>
      <div class="an-adn" id="adn_04"></div>
    </div>
  </div>
</template>
<script>
  import 'gsap'
  export default {
    name: 'Background',
    data () {
      return {
        msg: 'Card screen!',
        timeLine: -1
      }
    },
    methods: {
      playTween () {
        this.timeLine = new TimelineMax()
        this.timeLine.to('#adn_01', 20, {marginLeft: '-1264', ease: Linear.easeNone, repeat: -1}, 0)
          .to('#adn_02', 18, {marginRight: '-852', ease: Linear.easeNone, repeat: -1}, 0)
          .to('#adn_03', 50, {marginRight: '-1724', ease: Linear.easeNone, repeat: -1}, 0)
          .to('#adn_04', 10, {marginLeft: '-766', ease: Linear.easeNone, repeat: -1}, 0)
        this.timeLine.play()
      }
    },
    mounted () {
      this.playTween()
    }
  }
</script>
<style lang="scss">
  .background__inner {
    display: block;
    /*width: 1000px;*/
    /*height: 560px;*/
    width: 100%;
    height: 100%;
    margin: 0 auto;
    padding: 0;
    background: #33cc00;
    overflow: hidden;
    position: relative;
  }

  .an-adn {
    display: block;
    background: url("../assets/image/adn_01.png") repeat-x;
    width: 2528px;
    height: 132px;
    position: absolute;
    &#adn_01 {
      top: 272px;
    }
    &#adn_02 {
      background-size: auto 100%;
      height: 89px;
      width: (852*2) px;
      right: 0;
      top: 138px;
    }
    &#adn_03 {
      background-size: auto 100%;
      height: 180px;
      width: (1724*2) px;
      right: 0;
      bottom: -70px;
    }
    &#adn_04 {
      background-size: auto 100%;
      height: 80px;
      width: (766*2) px;
      top: -20px;
    }
  }
</style>



// WEBPACK FOOTER //
// Background.vue?5d8993e2